import { createContext } from "react";
import { NotificationContextValue } from "./notification.type";

/**
 * No-op notification API used when a consumer renders outside the provider,
 * so isolated component tests do not need to mount the whole wrapper.
 */
const noopNotificationContext: NotificationContextValue = {
    notify: () => undefined,
};

/**
 * React context that exposes the notification API to the component tree.
 */
export const NotificationContext = createContext<NotificationContextValue>(noopNotificationContext);
